import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import './app.css'

function NotFound() {
    return <div style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        width: '100%',
        // overflow: 'hidden'
    }}>
        <Header />
        <div
            style={{
                minHeight: window.innerWidth > 575 ? '80vh' : '55vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',  // vertical centering
                alignItems: 'center',      // horizontal centering
                textAlign: 'center',       // center text inside
                padding: '20px',           // optional, so it doesn't stick to edges on small screens
            }}
        >
            <p className="not-found-header" style={{ marginTop: 0 }}>
                404
            </p>
            <p className="not-found-text-bolder" style={{ marginTop: '20px' }}>
                LOOKS LIKE THIS PAGE DOESN’T EXIST!
            </p>
            <p className="not-found-text-normal" style={{ marginTop: '5px' }}>
                Go back to home and continue exploring.
            </p>
            <p style={{ marginTop: '30px' }}>
                <a href="/" className="not-found-link">
                    Back to home
                </a>
            </p>
        </div>

        <Footer />
    </div>
}

export default NotFound;
